import { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";
import { NAV_ITEMS } from "../data";

const GRADIENT = "linear-gradient(135deg, #29ABE2 0%, #5E5EDE 50%, #9B35C8 100%)";

export default function Sidebar() {
  const { page, navigate, user } = useApp();
  const [open, setOpen]   = useState(true);
  const [light, setLight] = useState(() => {
    return localStorage.getItem("vorsia-theme") === "light";
  });

  useEffect(() => {
    if (light) {
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
    }
    localStorage.setItem("vorsia-theme", light ? "light" : "dark");
  }, [light]);

  const handleSignOut = async () => {
    try {
      window.localStorage.clear();
      window.location.href = "/";
    } catch (err) {
      window.location.href = "/";
    }
  };

  return (
    <aside style={{
      width: open ? 220 : 60,
      flexShrink: 0,
      background: light ? "#ffffff" : "rgba(255,255,255,0.02)",
      borderRight: light ? "1px solid rgba(94,93,222,0.15)" : "1px solid rgba(255,255,255,0.07)",
      display: "flex",
      flexDirection: "column",
      transition: "width 0.25s cubic-bezier(0.34,1.56,0.64,1), background 0.25s ease",
      overflow: "hidden",
    }}>
      {/* Logo */}
      <div style={{ height:58, display:"flex", alignItems:"center", padding:"0 16px", borderBottom: light ? "1px solid rgba(94,93,222,0.12)" : "1px solid rgba(255,255,255,0.07)", flexShrink:0 }}>
        {open ? (
          <img src="/vorsia_ai.png" alt="Vorsia" style={{ height:36, width:"auto", objectFit:"contain", flexShrink:0 }} />
        ) : (
          <div style={{ width:28, height:28, background:GRADIENT, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
            <span style={{ color:"#fff", fontWeight:800, fontSize:13 }}>V</span>
          </div>
        )}
        <button onClick={() => setOpen(o => !o)} style={{ marginLeft:"auto", background:"none", border:"none", color: light ? "rgba(0,0,0,0.3)" : "rgba(255,255,255,0.3)", cursor:"pointer", fontSize:14, padding:4 }}>
          {open ? "◀" : "▶"}
        </button>
      </div>

      {/* Nav */}
      <nav style={{ flex:1, padding:"10px 8px", overflowY:"auto" }}>
        {NAV_ITEMS.map(item => (
          <button key={item.id} onClick={() => navigate(item.id)}
            style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 10px", borderRadius:10, marginBottom:2, cursor:"pointer", border:"none", background:page===item.id?"rgba(94,93,222,0.12)":"transparent", color:page===item.id?"#5E5EDE": light ? "rgba(0,0,0,0.55)" : "rgba(255,255,255,0.45)", fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:page===item.id?600:400, transition:"all 0.18s", textAlign:"left", position:"relative" }}
            onMouseEnter={e => { if (page!==item.id) e.currentTarget.style.background= light ? "rgba(94,93,222,0.07)" : "rgba(255,255,255,0.04)"; }}
            onMouseLeave={e => { if (page!==item.id) e.currentTarget.style.background="transparent"; }}>
            <span style={{ fontSize:16, flexShrink:0, width:24, textAlign:"center" }}>{item.icon}</span>
            {open && <span style={{ whiteSpace:"nowrap" }}>{item.label}</span>}
            {item.badge && open && <span style={{ marginLeft:"auto", background:"#7B6FE8", color:"#fff", fontSize:10, fontWeight:700, width:18, height:18, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center" }}>{item.badge}</span>}
            {item.badge && !open && <div style={{ position:"absolute", top:6, right:6, width:7, height:7, borderRadius:"50%", background:"#7B6FE8" }} />}
          </button>
        ))}
      </nav>

      {/* Bottom controls */}
      <div style={{ padding:"10px 8px", borderTop: light ? "1px solid rgba(94,93,222,0.12)" : "1px solid rgba(255,255,255,0.07)" }}>

        {/* For Employers link */}
        <a href="/?page=employers"
          style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 10px", borderRadius:10, marginBottom:4, textDecoration:"none", transition:"all 0.18s", background:"transparent" }}
          onMouseEnter={e => e.currentTarget.style.background= light ? "rgba(94,93,222,0.07)" : "rgba(255,255,255,0.04)"}
          onMouseLeave={e => e.currentTarget.style.background="transparent"}>
          <span style={{ fontSize:16, flexShrink:0, width:24, textAlign:"center" }}>🏢</span>
          {open && <span style={{ fontSize:13, color: light ? "rgba(94,93,222,0.7)" : "rgba(123,111,232,0.6)", fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap" }}>For Employers</span>}
        </a>

        {/* Theme Toggle */}
        <button onClick={() => setLight(l => !l)}
          style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 10px", borderRadius:10, cursor:"pointer", border:"none", background:"transparent", transition:"all 0.18s", marginBottom:4 }}
          onMouseEnter={e => e.currentTarget.style.background= light ? "rgba(94,93,222,0.07)" : "rgba(255,255,255,0.04)"}
          onMouseLeave={e => e.currentTarget.style.background="transparent"}>
          <span style={{ fontSize:16, flexShrink:0, width:24, textAlign:"center" }}>{light ? "🌙" : "☀️"}</span>
          {open && <span style={{ fontSize:13, color: light ? "rgba(0,0,0,0.55)" : "rgba(255,255,255,0.45)", fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap" }}>{light ? "Dark Mode" : "Light Mode"}</span>}
        </button>

        {/* Settings */}
        <button onClick={() => navigate("settings")}
          style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 10px", borderRadius:10, cursor:"pointer", border:"none", background:page==="settings"?"rgba(94,93,222,0.12)":"transparent", transition:"all 0.18s", marginBottom:4 }}
          onMouseEnter={e => { if (page!=="settings") e.currentTarget.style.background= light ? "rgba(94,93,222,0.07)" : "rgba(255,255,255,0.04)"; }}
          onMouseLeave={e => { if (page!=="settings") e.currentTarget.style.background="transparent"; }}>
          <div style={{ width:28, height:28, borderRadius:"50%", background:GRADIENT, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:"#fff", flexShrink:0 }}>
            {(user?.name||"U")[0].toUpperCase()}
          </div>
          {open && (
            <div style={{ textAlign:"left" }}>
              <div style={{ fontSize:12, fontWeight:600, color: light ? "#0f0f1e" : "rgba(255,255,255,0.75)", whiteSpace:"nowrap" }}>{user?.name||"User"}</div>
              <div style={{ fontSize:10, color: light ? "#6060a0" : "rgba(255,255,255,0.3)" }}>Settings</div>
            </div>
          )}
        </button>

        {/* Sign Out */}
        <button onClick={handleSignOut}
          style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"9px 10px", borderRadius:10, cursor:"pointer", border:"none", background:"transparent", transition:"all 0.18s" }}
          onMouseEnter={e => e.currentTarget.style.background="rgba(248,113,113,0.08)"}
          onMouseLeave={e => e.currentTarget.style.background="transparent"}>
          <span style={{ fontSize:16, flexShrink:0, width:24, textAlign:"center" }}>🚪</span>
          {open && <span style={{ fontSize:13, color:"rgba(248,113,113,0.6)", fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap" }}>Sign Out</span>}
        </button>
      </div>
    </aside>
  );
}
